import { isUndefined } from 'lodash';

import fetch from 'utilities/fetch';
import { paths } from 'config/path_helpers';

export const createAIPromptAnswer = (formData) => {
  const data = new URLSearchParams(formData);

  return fetch(paths.api.aiPromptAnswers(), {
    method: 'POST',
    body: data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then((response) => {
    return response.answer;
  });
};

export const createAITutoringSession = ({ domain, currentContext, initialSkill }) => {
  return fetch(paths.api.aiTutoringSessions(), {
    method: 'POST',
    body: JSON.stringify({
      tutoringSession: {
        domain,
        currentContext,
        initialSkill
      }
    })
  }).then((response) => {
    return response.tutoringSession;
  });
};

export const createAITutoringSessionAction = (tutoringSessionId: number, name: string, payload: any) => {
  return fetch(paths.api.aiTutoringSessionActions(tutoringSessionId), {
    method: 'POST',
    body: JSON.stringify({
      actionName: name,
      actionPayload: payload
    })
  }).then((response) => {
    return response.interactions;
  });
};

export const createAITutoringSessionAssistantInteraction = ({
  content = {},
  currentContext = null,
  parts = [],
  tutoringSessionId,
}) => {
  return fetch(paths.api.aiTutoringSessionAssistantInteractions(tutoringSessionId), {
    method: 'POST',
    body: JSON.stringify({
      interaction: {
        content,
        currentContext,
        parts
      }
    })
  }).then((response) => {
    return response.interactions;
  });
};

export const createAITutoringSessionContextChangeInteraction = ({
  content,
  tutoringSessionId,
}) => {
  return fetch(paths.api.aiTutoringSessionContextChangeInteractions(tutoringSessionId), {
    method: 'POST',
    body: JSON.stringify({
      interaction: {
        content
      }
    })
  }).then((response) => {
    return response.interactions;
  });
};

export const createAITutoringSessionUserInteraction = ({
  content,
  currentContext = null,
  tutoringSessionId,
}) => {
  return fetch(paths.api.aiTutoringSessionUserInteractions(tutoringSessionId), {
    method: 'POST',
    body: JSON.stringify({
      interaction: {
        content,
        currentContext
      }
    })
  }).then((response) => {
    return response.interactions;
  });
};

export const createOrUpdateRating = (rating) => {
  return fetch(paths.api.rating(rating.rateableId), {
    method: 'PUT',
    body: JSON.stringify(rating)
  });
};

export const fetchAvailableAITutoringSessionSkills = () => {
  const path = paths.api.aiTutoringSessionsAvailableSkills(window.location.pathname);
  return fetch(path).then((response) => {
    return response.tutoringSession.availableSkills;
  });
};

export const fetchAITutoringSessionInteraction = (tutoringSessionId: number, id: number) => {
  return fetch(paths.api.aiTutoringSessionInteraction(tutoringSessionId, id)).then((response) => {
    return response.interaction;
  });
};

export const fetchAITutoringSession = (id: number) => {
  return fetch(paths.api.aiTutoringSession(id)).then((response) => {
    return response.tutoringSession;
  });
};

export const fetchAITutoringSessions = (page: number, perPage?: number) => {
  return fetch(paths.api.aiTutoringSessions({ page, per_page: perPage || 50 })).then((response) => {
    return response.tutoringSessions;
  });
};

export const saveAITutoringUIState = (uiState) => {
  return fetch(paths.api.aiTutoringUIState(), {
    method: 'PUT',
    body: JSON.stringify({ uiState })
  });
};

export const updateAITutoringSession = (tutoringSession) => {
  return fetch(paths.api.aiTutoringSession(tutoringSession.id), {
    method: 'PUT',
    body: JSON.stringify({ tutoringSession })
  }).then((response) => {
    return response.tutoringSession;
  });
};

export const updateAITutoringSessionInteraction = (interaction) => {
  return fetch(paths.api.aiTutoringSessionInteraction(interaction.tutoringSessionId, interaction.id), {
    method: 'PUT',
    body: JSON.stringify({ interaction })
  }).then((response) => {
    return response.interaction;
  });
};

export const updateAITutoringSessionInteractionPart = (interactionPart) => {
  const path = paths.api.aiTutoringSessionInteractionPart(
    interactionPart.tutoringSessionId,
    interactionPart.interactionId,
    interactionPart.id
  );

  return fetch(path, {
    method: 'PUT',
    body: JSON.stringify({ interactionPart })
  }).then((response) => {
    return response.interactionPart;
  });
};
